// src/i18n/index.js
import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import en from "./translations/en.json";
import fr from "./translations/fr.json";
import ar from "./translations/ar.json";
import de from "./translations/de.json";

export const STORAGE_LANG_KEY = "site_lang";
export const SAFE_LOCALES = ["en", "fr", "ar", "de"];

const resources = { en, fr, ar , de };

const detectLangInitial = () => {
  try {
    const v = localStorage.getItem(STORAGE_LANG_KEY);
    if (v && SAFE_LOCALES.includes(v)) return v;
  } catch {}
  try {
    const nav = (navigator.language || "en").split("-")[0];
    if (SAFE_LOCALES.includes(nav)) return nav;
    return "en";
  } catch {
    return "en";
  }
};

const I18nContext = createContext({
  lang: "en",
  t: (k, vars) => k,
  setLang: (l) => {},
});

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => detectLangInitial());

  useEffect(() => {
    const onStorage = (e) => {
      if (!e) return;
      if (e.key === STORAGE_LANG_KEY) {
        const newVal = e.newValue || null;
        if (newVal && SAFE_LOCALES.includes(newVal) && newVal !== lang) {
          setLangState(newVal);
        }
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [lang]);

  const setLang = useCallback((newLang) => {
    if (!newLang || !SAFE_LOCALES.includes(newLang)) return;
    try {
      localStorage.setItem(STORAGE_LANG_KEY, newLang);
    } catch {}
    setLangState(newLang);
    try {
      
    } catch {}
  }, []);

  useEffect(() => {
    if (lang === "ar") {
      document.documentElement.setAttribute("dir", "rtl");
      document.documentElement.classList.add("rtl");
    } else {
      document.documentElement.setAttribute("dir", "ltr");
      document.documentElement.classList.remove("rtl");
    }
  }, [lang]);

  const t = useCallback(
    (key, vars = {}) => {
      const dict = resources[lang] || resources.en;
      let str = dict[key] ?? resources.en[key] ?? key;
      Object.keys(vars).forEach((k) => {
        str = str.replace(new RegExp(`\\{${k}\\}`, "g"), String(vars[k]));
      });
      return str;
    },
    [lang]
  );

  return <I18nContext.Provider value={{ lang, t, setLang }}>{children}</I18nContext.Provider>;
}

export function useTranslation() {
  return useContext(I18nContext);
}
